import {Component, EventEmitter, Input, Output} from '@angular/core';
import {faSpinner} from "@fortawesome/free-solid-svg-icons";
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

@Component({
  selector: 'app-common-button',
  templateUrl: './common-button.component.html',
  styleUrl: './common-button.component.scss',
  standalone: false
})

export class CommonButtonComponent {

  @Input() buttonClass      : string = '';
  @Input() custButtonClass  : string = '';
  @Input() disableButtonClass: string = '';
  @Input() buttonLabel      : string = '';
  @Input() type             : string = '';
  @Input() disabled         : boolean = false;
  @Input() loadingIcon      : boolean = false;
  @Input() isImg            : string = '';
  @Input() typeBtn          : boolean = false;
  @Input() onClick          : any;
  @Input() leftIcon         : IconDefinition | null = null;
  @Output() clickEvent      : EventEmitter<any> = new EventEmitter<void>();

  protected readonly faSpinner = faSpinner;

  onClickEvent(event: any) {
    if (!this.loadingIcon && !this.disabled) {
      this.clickEvent.emit();
    }
  }
}
